export const BUYER_STEPS = [
  { title: 'capital.transfer.details.steps.BUYER_SIGN', type: 'BUYER_SIGN' },
  {
    title: 'capital.transfer.details.steps.SEND_PAYMENT_AND_CONFIRM',
    type: 'SEND_PAYMENT_AND_CONFIRM',
  },
] as const;
